module.exports = __webpack_public_path__ + "images/scalping-ec3abb.png";